export default "__VITE_ASSET__dNsb_6x8__"